const headList = [
  { headTitle: "施設名称" },
  { headTitle: "施設種類" },
  { headTitle: "施設区分" },
  { headTitle: "解除年月日" },
  { headTitle: "部分解除の人数" },
  { headTitle: "解除同意書" },
  { headTitle: "解除理由" },
  { headTitle: "直近3カ月の退職者の証明書" },
];

const symbolHeadList: any = [
  { headTitle: "帳票名", align: "left" },
  { headTitle: "記号番号", align: "left" },
  { headTitle: "決裁日", align: "left" },
];

export { headList, symbolHeadList };
